import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const activeModuleSlice = createSlice({
    name: "activeModule",
    initialState: { value: "Overview" },
    reducers: {
        updateActiveModule: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

export const { updateActiveModule } = activeModuleSlice.actions;
export default activeModuleSlice.reducer;
